const WEBVIEW_QUERY_PARAM = 'webview';
const WEBVIEW_SESSION_KEY = 'isWebView';

let isWebViewSession = false;

const readPersistedFlag = () => {
  try {
    return sessionStorage.getItem(WEBVIEW_SESSION_KEY) === 'true';
  } catch {
    return false;
  }
};

export const initWebViewMode = () => {
  const params = new URLSearchParams(window.location.search);
  isWebViewSession =
    params.get(WEBVIEW_QUERY_PARAM) === 'true' || readPersistedFlag();

  if (!isWebViewSession) return;
  try {
    sessionStorage.setItem(WEBVIEW_SESSION_KEY, 'true');
  } catch {
    // WebView may block storage; in-memory flag covers the current load
  }
};

export const isWebView = () => isWebViewSession;
